import { Vue } from 'nuxt-property-decorator'
import formatPrice from '@mg/web-components/filters/formatPrice'
import { GQLConfig } from '~/graphql/__generated__/interfaces'

const formatPriceFactory = ({
  priceRound,
  currency,
  thousandSeparator,
  decimalsSeparator,
}: GQLConfig['shopConfig']) => {
  Vue.filter(
    'formatPrice',
    formatPrice({
      currency,
      decimalSeparator: decimalsSeparator,
      decimals: priceRound,
      thousandSeparator,
    })
  )
}

export default formatPriceFactory
